import { render } from "./aboutuspage.vue?vue&type=template&id=1a065900&scoped=true"
import script from "./aboutuspage.vue?vue&type=script&lang=js"
export * from "./aboutuspage.vue?vue&type=script&lang=js"

import "./aboutuspage.vue?vue&type=style&index=0&id=1a065900&lang=css"
import "./aboutuspage.vue?vue&type=style&index=1&id=1a065900&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a065900"]])

export default __exports__